import type { TAzimuthReference } from '../types/trajectory-measure';

export function isAzimuthReference(value: string | null | undefined): value is TAzimuthReference {
  return value === 'TRUE' || value === 'GRID' || value === 'MAGNETIC';
}
